import {defineStore} from "pinia";
import useCrudStore from "@/store/composables/crud";
import environment from "@/environment";
import httpClient from "@/tools/http-client";

const DEFAULT_PRICE_LIST_ITEMS_PER_PAGE = 20;

export const useShopStore
    = defineStore('shopStore', () => {

        const priceItemsEndpoint = environment.appConfig.baseApiUrl + "price-list-items";
        const priceItemEndpoint = environment.appConfig.baseApiUrl + "price-list-item";

    const crud = useCrudStore(priceItemsEndpoint);

    async function loadData(metaParams) {
        console.log("loadTopPriceItems");
        crud.startLoading();
        try {
            const startPage = Number(metaParams.page || 0) + 1;
            const perPage = Number(metaParams.per_page || DEFAULT_PRICE_LIST_ITEMS_PER_PAGE);
            metaParams.page = startPage;
            metaParams.per_page = perPage;

            const resp = await httpClient.get(priceItemsEndpoint, {params: metaParams});
            if (resp.data.status === 'error') {
                crud.setError(resp.data.message);
                return
            }
            console.log('loaded data',  resp.data.price_list_items )
            crud.addItems(resp.data.price_list_items);
            crud.clearLoading();
        } catch (e) {
            crud.setError(e);
        }
    }

    async function loadPriceItem({price_list_item_id}) {
        console.log("loadPriceItem");
        crud.startLoading();
        // Ищу, может уже есть с таким ID
        const found = crud.data?.find(item => item.id === price_list_item_id);
        if(found) {
            crud.clearLoading();
            crud.setRecord(found);
            return;
        }
        try {
            const params = {price_list_item_id};
            const resp = await httpClient.get(priceItemEndpoint, {params});
            if (resp.data.status === 'error') {
                crud.setError(resp.data.message);
                return
            }
            crud.setRecord(resp.data.price_list_item);
            crud.clearLoading();
        }catch (e) {
            crud.setError(e);
        }
    }
    return {
        ...crud,
        loadData,
        loadPriceItem,
    }
});
